<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div v-if="form.user != ''" class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/users/list/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Felhasználó</h1>
          <div class="row">
            <div class="col-xs-6">
              <select2ajax :change="dnChange" v-if="shib" method="post" :errors="errors" :url="'user/searchdn/' + $root.user.apikey + '/' + form.user.element_id" label="Címtár" id="dn" name="dn" v-model="form.user.dn"></select2ajax>
              <inputbox regexp_filter="[a-zA-Z. öüóőúéáűíÖÜÓŐÚÉÁŰÍ0-9-]+" id="name" label="Név" v-bind:errors="errors" name="fullname" v-model="form.user.name"></inputbox>
              <inputbox id="email" label="Email" v-bind:errors="errors" name="email" v-model="form.user.email"></inputbox>
              <inputbox v-if="!shib" id="password" label="Jelszó" v-bind:errors="errors" name="password" v-model="form.user.password"></inputbox>
              <inputbox v-if="!shib" id="password_" label="Jelszó újra" v-bind:errors="errors" name="password_" v-model="form.user.password_"></inputbox>
              <toggle id="filter_element" label="Csoportképzésnél szűrő" name="filter_element" v-model="form.user.filter_element"></toggle>
              <toggle id="barcode_period_fix" label="Vonalkód beállítás fix 24 óra" name="barcode_period_fix" v-model="form.user.barcode_period_fix"></toggle>
              <select2 multi="true" label="Vonalkód igénylés csoportok" name="barcode_req_groups" id="barcode_req_groups" :options="usertype_groups" v-model="form.user.barcode_request_groups"/>
              <select2 multi="true" label="Kártya csoportok" name="card_groups" id="card_groups" :options="card_groups" v-model="form.user.card_groups"/>
            </div>
            <div class="col-xs-6">
              <ulRight rootClass="tree" v-bind:rights="form.rights"/>
            </div>
          </div>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
import Vue from 'vue';

Vue.component('ulRight', {
  props: ['rights','rootClass'],
  template: `<ul v-bind:class="rootClass">
<li v-for="right in rights">
  <div>
    <span v-on:click="expandClick(right)" class="expand-icon"><i v-if="right.childs" v-bind:class="toggleClass(right)"></i></span>
    <span class="icon"><i class="fa fa-folder"></i></span>
    <div v-on:click="rightClick(right)" class="checkbox">
      <input type="checkbox" v-bind:id="right.id" v-bind:name="right.id" v-bind:value="right.id" v-model="right.selected">
      <label v-bind:for="right.id">{{ right.name }}</label>
    </div>

    <ulRight v-show="right.open" v-if="right.childs" v-bind:rights="right.childs"/>
  </div>
</li>
</ul>`,
  methods: {
    expandClick: function(right) {
      right.open = !right.open;
    },

    toggleClass: function(right) {
      return right.open ? 'fa fa-minus' : 'fa fa-plus';
    },

    setRightChilds: function(right, selected) {
      var _this = this;

      if (right.childs == undefined || right.childs.length == 0)
        return;

      right.childs.map(function(right_child) {
        right_child.selected = selected;
        _this.setRightChilds(right_child, selected);
      });
    },

    rightClick: function(right) {
      this.setRightChilds(right, right.selected);
    }
  }
});

export default {
  data: function() {
    return {
      form: {
        user: '',
        rights: []
      },
      errors: [],
      usertype_groups: [],
      card_groups: [],
      is_save: false,
      shib: true
    }
  },
  mounted: function() {
    var _this = this;

    if (this.$route.params[0] != undefined && this.$route.params[0] == '*') {
      this.shib = false;
    }

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('user/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.userID != undefined ? _this.$route.query.userID : 0) + '/' + (_this.shib ? 1 : 0), {
        success: function(response) {
          response.user.password_ = response.user.password;
          _this.form.user = response.user;
          _this.form.rights = response.rights;
          _this.usertype_groups = response.usertype_groups;
          _this.card_groups = response.card_groups;
        }
      });
    });
  },
  methods: {
    dnChange: function() {
      var _this = this;

      this.$root.ajax('user/get_by_dn/' + this.$root.user.apikey, {
        method: 'POST',
        data: {
          dn: this.form.user.dn.selected
        },
        success: function(response) {
          if (response.shib_user != undefined) {
            _this.form.user.name = response.shib_user.name;
            _this.form.user.email = response.shib_user.email;
          }
        }
      });
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.ajax('user/save/' + _this.$root.user.apikey + '/' + (_this.shib ? 1 : 0), {
        method: 'POST',
        data: {
          data: form
        },
        waitForSaveInfo: true,
        success: function(response) {
          _this.is_save = false;

          if (response.errors.length > 0) {
            _this.errors = response.errors;
          } else {
            _this.$router.push({path: '/users/list'});
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// user.vue?4fc56522